import React, { useState } from "react";

export const Context = React.createContext();

const ContextManager = (props) => {
  const [user, setUser] = useState(null);
  const [propertyUnitDocuments, setPropertyUnitDocuments] = useState([]);
  const [tabTitle, setTabTitle] = useState("");
  const [bankAccounts, setBankAccounts] = useState([]);
  const [allTransactions, setAllTransactions] = useState([]);
  const [plaidToken, setPlaidToken] = useState(null);
  const [propertyManagerInfo, setPropertyManagerInfo] = useState(null);
  const [dueData, setDueData] = useState({
    dueAmount: 0,
    dueDate: "",
    avaAmount: 0,
  });

  return (
    <Context.Provider
      value={{
        user,
        setUser,
        propertyUnitDocuments,
        setPropertyUnitDocuments,
        tabTitle,
        setTabTitle,
        bankAccounts,
        setBankAccounts,
        allTransactions,
        setAllTransactions,
        plaidToken,
        setPlaidToken,
        propertyManagerInfo,
        setPropertyManagerInfo,
        dueData,
        setDueData,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default ContextManager;
